import { Form, Input, message } from 'antd';
import React, { useState } from 'react';
import cn from 'classnames';
import DispexButton from '../../../../components/DispexButton/DispexButton';
import { ensureMaxPhone } from '../../requests/ensureMaxPhone';
import { getVerificationCode } from '../../requests/getVerificationCode';
import styles from './MaxPhoneForm.module.scss';

const MAX_VERIFICATION_TYPE_ID = 5;

const getNeedsPhone = (response) =>
  response?.needsPhone || response?.NeedsPhone;

const normalizePhone = (value) => {
  const digits = String(value || '').replace(/\D/g, '');

  if (digits.length === 10) {
    return `7${digits}`;
  }

  if (digits.length === 11 && digits[0] === '8') {
    return `7${digits.slice(1)}`;
  }

  return digits;
};

const MaxPhoneFormNode = ({
  form,
  username,
  password,
  setStep,
  onVerificationCodeResponse,
}) => {
  const { getFieldDecorator, validateFieldsAndScroll } = form;
  const [submitting, setSubmitting] = useState(false);

  const goToMethodSelect = () => {
    if (typeof setStep === 'function') {
      setStep(2);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    validateFieldsAndScroll(async (err, values) => {
      if (err || submitting) {
        return;
      }

      const phone = normalizePhone(values.phone);
      setSubmitting(true);

      const authParameter = {
        login: username,
        password: password,
      };

      const phoneResponse = await ensureMaxPhone({
        login: username,
        password,
        phone,
      });

      if (!phoneResponse) {
        setSubmitting(false);
        return;
      }

      const verificationCodeResponse = await getVerificationCode({
        authParameter,
        verificationTypeId: MAX_VERIFICATION_TYPE_ID,
      });

      setSubmitting(false);

      if (!verificationCodeResponse) {
        return;
      }

      if (getNeedsPhone(verificationCodeResponse)) {
        message.error('Не получилось привязать телефон для входа через Max');
        return;
      }

      if (typeof onVerificationCodeResponse === 'function') {
        await onVerificationCodeResponse(verificationCodeResponse);
        return;
      }

      if (typeof setStep === 'function') {
        setStep(3);
      }
    });
  };

  return (
    <Form
      onSubmit={handleSubmit}
      className={styles.root}
    >
      <p className="login_page-main-title">Телефон для Max</p>
      <div className={styles.text}>
        Укажите номер телефона, чтобы привязать его к профилю и получить код в
        боте Max.
      </div>
      <Form.Item className={styles.field}>
        {getFieldDecorator('phone', {
          normalize: normalizePhone,
          rules: [
            { required: true, message: 'Введите телефон' },
            {
              validator: (_rule, value, callback) => {
                const phone = normalizePhone(value);

                if (/^7\d{10}$/.test(phone)) {
                  callback();
                  return;
                }

                callback('Введите корректный телефон');
              },
            },
          ],
        })(
          <Input
            className="input"
            placeholder="79991234567"
            maxLength={18}
            disabled={submitting}
          />
        )}
      </Form.Item>
      <div className={styles.actions}>
        <DispexButton
          onClick={goToMethodSelect}
          type="secondary"
          htmlType="button"
          className={cn('login_page-main-entry_button', styles.secondaryBtn)}
          disabled={submitting}
        >
          Назад
        </DispexButton>
        <DispexButton
          htmlType="submit"
          type="primary"
          className="login_page-main-entry_button"
          loading={submitting}
          disabled={submitting}
        >
          Продолжить
        </DispexButton>
      </div>
    </Form>
  );
};

export const MaxPhoneForm = Form.create({ name: 'max_phone_form' })(
  MaxPhoneFormNode
);
